import type { CardFilters } from '../types/card.types';

/**
 * Mapea los filtros de la UI de Tarjeta a los query params de la consulta de
 * tarjetas asignadas (`card-list`).
 *
 * Contrato parcial (seam BF-623): `search`, `status`, `type`, `tags` (OR) y
 * `no_limit` son la extensión pendiente en el BE. Se aísla aquí para ajustar
 * las llaves cuando aterrice esa tarea.
 */
export function buildCardListParams(filters: CardFilters = {}): Record<string, string | boolean> {
  const params: Record<string, string | boolean> = {};

  const search = filters.search?.trim();
  if (search) params.search = search;
  if (filters.status) params.status = filters.status;
  if (filters.type) params.type = filters.type;
  if (filters.tags && filters.tags.length > 0) params.tags = filters.tags.join(',');
  if (filters.noLimit) params.no_limit = true;

  return params;
}

/** ¿Hay algún criterio cargado? Controla el estado del botón "Aplicar filtros". */
export function hasAnyCardFilter(filters: CardFilters = {}): boolean {
  return Boolean(
    filters.search?.trim() ||
      filters.status ||
      filters.type ||
      (filters.tags && filters.tags.length > 0) ||
      filters.noLimit,
  );
}
